import * as React from 'react';

export const Loading: React.FC<React.SVGAttributes<SVGSVGElement>> = ({ width = 160, height = 160, ...props }) => {
  return (
    <div className='grid w-[160px] mx-auto'>
      <svg
        className='animate-spin col-start-1 row-start-1'
        fill='none'
        height={height}
        viewBox='0 0 160 160'
        width={width}
        xmlns='http://www.w3.org/2000/svg'
        {...props}
      >
        <circle
          cx='80'
          cy='80'
          r='79'
          stroke='#FFFFFF'
          strokeDasharray='100 80'
          strokeLinecap='round'
          strokeWidth='2'
        />
      </svg>
      <svg
        className='col-start-1 row-start-1'
        fill='none'
        height={height}
        viewBox='0 0 160 160'
        width={width}
        xmlns='http://www.w3.org/2000/svg'
        {...props}
      >
        <path
          d='M39.8694 105.206L38.1913 106.908H40.5815H79.3924C82.3199 115.12 90.6952 121 100.433 121C112.216 121 121.993 112.394 122.558 101.477H122.584V100.477V99.4773H122.558C122.31 94.6903 120.29 90.2651 117.108 86.8942L116.744 86.5089C116.836 86.4189 116.926 86.3278 117.017 86.2356L117.024 86.2276C120.474 82.6156 122.584 77.8575 122.584 72.6403C122.584 61.2469 112.574 52.1177 100.433 52.1177C94.5716 52.1177 89.2069 54.2471 85.2254 57.731C84.8384 55.093 83.988 52.6029 82.6724 50.2673C80.8078 46.891 78.1819 44.1691 74.8123 42.109C71.4689 40.0243 67.5578 39 63.1177 39C57.7866 39 53.2246 40.0437 49.4805 42.1875C45.7837 44.2388 42.9155 46.9563 40.9074 50.3431L40.9074 50.3431L40.9042 50.3485C38.9725 53.6542 38 57.1822 38 60.9169C38 62.6762 38.3164 64.6756 38.9249 66.903L38.9286 66.9165L38.9327 66.9299C39.6159 69.1804 40.5723 71.3277 41.8001 73.3704C43.0617 75.4694 44.6342 77.0568 46.5329 78.0773L47.1574 78.413L47.6809 77.9347L54.6987 71.5215L55.451 70.8341L54.7495 70.0949C53.6511 68.9376 52.7616 67.5952 52.0824 66.0605C51.4805 64.4892 51.1693 62.6811 51.1693 60.6209C51.1693 59.3636 51.5112 58.08 52.2329 56.7592L52.2374 56.7511L52.2416 56.7429C52.9411 55.4046 53.9946 54.2841 55.4353 53.3837C56.8859 52.5172 58.7682 52.0504 61.1409 52.0504C64.0232 52.0504 66.4633 52.9013 68.5121 54.5855L68.519 54.5912L68.526 54.5967C70.4568 56.1272 71.5078 58.5542 71.5078 62.1008C71.5078 65.1346 70.6714 68.2989 68.9519 71.6045L68.9484 71.6113L68.945 71.6181C67.2735 74.955 64.9482 78.4095 61.9558 81.9808C58.9442 85.5751 55.5361 89.3046 51.7302 93.1691C47.9084 97.0498 43.9548 101.062 39.8694 105.206ZM101.792 93.1142C102.018 93.0967 102.259 93.0734 102.512 93.0439L104.417 94.0469C106.838 95.3217 108.441 97.7882 108.441 100.477C108.441 104.436 104.925 107.792 100.433 107.792C95.9409 107.792 92.425 104.436 92.425 100.477C92.425 96.5186 95.9409 93.163 100.433 93.163C100.533 93.163 100.633 93.1623 100.733 93.1611L100.757 93.1619L101.792 93.1989V93.1142ZM75.3638 84.5311C76.8294 82.7025 78.164 80.855 79.3669 78.9885C80.3024 81.6453 81.8074 84.0628 83.7425 86.1165L84.162 86.5617C82.0914 88.6386 80.4732 91.1165 79.4631 93.8574H67.7314C70.3471 90.725 72.8912 87.6162 75.3638 84.5311ZM100.678 79.9493C99.9009 79.9525 99.1475 79.989 98.4188 80.0541L96.3361 78.9174C93.9665 77.6242 92.425 75.2754 92.425 72.6404C92.425 68.6817 95.9409 65.326 100.433 65.326C104.925 65.326 108.441 68.6816 108.441 72.6403C108.441 76.4991 105.103 79.7835 100.772 79.9491L100.765 79.9491L100.749 79.9491L100.733 79.9496L100.728 79.9497L100.694 79.9493L100.686 79.9492L100.678 79.9493Z'
          stroke='#FFFFFF'
          strokeWidth='2'
        />
        <path
          d='M83.916 86.1567C86.3521 83.6027 93.7686 79.7566 99.2761 79.7566'
          stroke='#FFFFFF'
          strokeLinecap='square'
          strokeWidth='1.6'
        />
        <path
          d='M117.217 86.6206C114.781 89.2012 106.371 93.374 101.86 93.374'
          stroke='#FFFFFF'
          strokeLinecap='square'
          strokeWidth='1.6'
        />
      </svg>
    </div>
  );
};
